<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div v-if="!isProcessing">
      <DiagCorpHeader
        v-if="!isRendering"
        :corpName="this.corpName"
        :corporateFeatureInfoLabels="this.corporateFeatureInfoLabels"
        :corporateSelectable="isAdmin"
        :manageCorpName="manageCorpName"
        :isAdmin="isAdmin"
        :isDiagAvailablePlan="isDiagAvailablePlan"
        @select-corporate="emitSelectCorpList"
      ></DiagCorpHeader>
    </div>

    <div class="l-contents">
      <h1 class="l-pageTitle">
        <span class="l-pageLabel">定着</span>離職率
      </h1>

      <!-- タブ表示 -->
      <div class="l-acount-tab">
        <ul>
          <li><a @click="goPages(hrType, 'input')">実績・目標の編集</a></li>
          <li class="is-current"><a @click="goPages(hrType, 'report')">レポート</a></li>
        </ul>
      </div>

      <div class="l-contentsBox">
        <div class="l-contentsSection">
          <div class="btn-print-wrap">
            <div class="btn-print" :class="{'off': showButton===false, 'on': showButton===true}">
              <button v-if="showButton" class="js-print" @click="print">レポートを印刷する</button>
            </div>
          </div>
          <p class="l-text u-mb30">高い離職率は企業に多くの悪影響をもたらします。採用・トレーニングコストの増加、クライアントや取引先との信頼低下、従業員の経験とスキルが不足している新規従業員が頻繁に入れ替わると、サービス品質の低下につながる可能性があります。</p>
          <div class="l-blueBox u-mb30">
            <p class="l-headding is-small has-icon icon-lg is-blue u-mb20"><img src="@/assets/img/common/icon-point.svg" alt="" class="icon">離職率を下げるためには</p>

            <dl class="l-check-data-list">
              <dt>定期的な従業員への意識調査</dt>
              <dd>職場風土や働きやすさ等定期的な調査の実施と改善策の実行を行いましょう。</dd>

              <dt>柔軟性のある働き方</dt>
              <dd>フレキシブルな労働条件やリモートワークのオプションを提供し、従業員ニーズに合わせた柔軟性を重視します。</dd>

              <dt>働きやすい環境の整備</dt>
              <dd>コミュニケーションの円滑化やハラスメント防止、ワークライフバランスを支援しましょう。</dd>
            </dl>

          </div>
          <div class="l-hr"><hr></div>

          <!-- 最新年の実績未入力時のアラート -->
          <div class="alert-box" v-show="this.noCurrentDataAlert">
            <p>最新年度の実績が入力されていません。<br>
            実績・目標の編集画面で、必要な情報を入力してください。</p>
            <div class="btn-basic-small"><a @click="goPages(hrType, 'input')">実績・目標の編集</a></div>
          </div>

          <div class="human-capitalt-view-wrap">
            <div class="human-capitalt-view-wrap__table">
              <p class="l-formGroup__label u-mb10">離職率</p>
              <table class="human-capitalt-data-table">
                <thead>
                  <tr>
                    <th></th>
                    <th>男性</th>
                    <th>女性</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>{{turnover.year}}年{{this.accountMonth}}月期実績</th>
                    <td>
                      <span class="human-capitalt-data-table__text"><strong><Currency :value="turnover.achievementMaleTurnover" :unit="this.unit"/></strong></span>
                    </td>
                    <td>
                      <span class="human-capitalt-data-table__text"><strong><Currency :value="turnover.achievementFemaleTurnover" :unit="this.unit"/></strong></span>
                    </td>
                  </tr>
                  <tr>
                    <th>業界平均
                      <span class="icon-help" data-tooltip-pos="right"
                        data-tooltip='厚生労働省「<a href="https://positive-ryouritsu.mhlw.go.jp/positivedb/opendata/" target="_blank">女性の活躍推進企業データベースオープンデータ（令和６年４月１８日時点</a>）」を加工して作成しています。<br>ただし、年間平均賃金および平均年齢は、国税庁「民間給与実態統計調査結果令和４年度」のデータを加工して作成しています。'><img src="@/assets/img/common/icon-help.svg" alt="" width="16px"></span></th>
                    <td>
                      <span class="human-capitalt-data-table__text"><Currency :value="turnoverMale" :unit="this.unit"/></span>
                    </td>
                    <td>
                      <span class="human-capitalt-data-table__text"><Currency :value="turnoverFemale" :unit="this.unit"/></span>
                    </td>
                  </tr>
                  <tr>
                    <th>目標</th>
                    <td>
                      <span class="human-capitalt-data-table__text"><Currency :value="turnover.goalMaleTurnover" :unit="this.unit"/></span>
                    </td>
                    <td>
                      <span class="human-capitalt-data-table__text"><Currency :value="turnover.goalFemaleTurnover" :unit="this.unit"/></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
<!--            <div class="human-capitalt-view-wrap__body">
              <div class="l-formGroup">
                <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
                <TextArea class="l-formGroup__textArea is-highMiddle" v-model="turnover.resultMemo" @input="changeInput()" ></TextArea>
              </div>
              <ValidationErrorMessage v-show="$v.turnover.resultMemo.$invalid && !$v.turnover.resultMemo.maxLength" validation="maxLength" valueLength="300" />
            </div>-->
            <div class="human-capitalt-view-wrap__body">
              <p class="l-formGroup__label u-mb10">実績に関するメモ</p>
              <div class="human-capitalt-view-wrap__contents">
                <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(turnover.resultMemo)"></p>
              </div>
            </div>

          </div><!--human-capitalt-data-wrap-->

        </div>
        <div class="l-contentsSection">

          <div class="human-capitalt-data-past" ref="header">
            <div class="human-capitalt-data-past__header" >
              <p class="human-capitalt-data-past__label">実績の詳細（直近5年）</p>
            </div>
            <div class="human-capitalt-data-past__body" ref="body">
              <TurnoverDetail
                :turnover="turnover"
                :month="accountMonth"
                ref="TurnoverDetail"></TurnoverDetail>
              <TurnoverDetail
                :turnover="turnover_1"
                :month="accountMonth"
                ref="TurnoverDetail1"></TurnoverDetail>
              <TurnoverDetail
                :turnover="turnover_2"
                :month="accountMonth"
                ref="TurnoverDetail2"></TurnoverDetail>
              <TurnoverDetail
                :turnover="turnover_3"
                :month="accountMonth"
                ref="TurnoverDetail3"></TurnoverDetail>
              <TurnoverDetail
                :turnover="turnover_4"
                :month="accountMonth"
                ref="TurnoverDetail4"></TurnoverDetail>
            </div>
          </div><!--/human-capitalt-data-past-->

          <h2 class="heading-lv2 u-mt30">5年間の推移</h2>
          <div class="line-chart-legend">
            <p class="line-chart-legend__data">実績</p>
            <p class="line-chart-legend__target">目標</p>
          </div>

          <div class="l-contentsGrid2">
            <div class="l-contentsGrid2__item u-mb40">
              <div>
                <p class="l-formGroup__label u-mb10">男性</p>
                <TurnoverLineChart
                  ref="lineChart"
                  :startYear="this.startYear"
                  :corpId="this.corpId"
                  :dataType="1"
                  :unit="this.unit"
                  class="line-chart-canvas"
                ></TurnoverLineChart>
              </div>
            </div><!--/l-contentsGrid2__item"-->
            <div class="l-contentsGrid2__item u-mb40">
              <div>
                <p class="l-formGroup__label u-mb10">女性</p>
                <TurnoverLineChart
                  ref="lineChart2"
                  :startYear="this.startYear"
                  :corpId="this.corpId"
                  :dataType="2"
                  :unit="this.unit"
                  class="line-chart-canvas"
                ></TurnoverLineChart>
              </div>
            </div><!--/l-contentsGrid2__item"-->

          </div><!--/l-contentsGrid2-->
        </div>


        <div class="l-contentsSection">
          <div class="l-contentsBox">
            <div class="l-contentsBox__header">
              <h2 class="heading-lv2 mb-0">今後の取り組み</h2>
            </div>
            <div class="l-contentsGrid2">


              <div class="l-contentsGrid2__item">
                <div class="l-contentsMemo" ref="memoEdit">
                  <div class="l-formGroup">
                    <div class="l-contentsMemo__title">
                      <label class="l-formGroup__label">具体的なアクション</label>
                      <button class="link-arrow is-normal js-memo-edit" @click="editMode()">編集する</button>
                      <button class="link-arrow is-edit js-memo-exit" @click="editMode()">編集を終わる</button>
                    </div>
                    <div class="l-contentsMemo__body">
                      <div class="l-grayBox is-normal" style="min-height:108px;">
                        <div>
                          <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(turnover.actionMemo)"></p>
                        </div>
                      </div>
                    </div>
                    <TextArea class="l-formGroup__textArea is-highMiddle is-edit" v-model="turnover.actionMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.turnover.actionMemo.$invalid && !$v.turnover.actionMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div>
              <div class="l-contentsGrid2__item">
<!--                <div>
                  <p class="l-formGroup__label">取り組みガイド<span style="color:red; font-size: 1.5rem;padding-left:10px;" v-if="this.guideCode==null" >※取り組みガイドが登録されていません。</span></p>
                  <div class="btn-download-guide" >
                    <a v-bind:class="{'disabled-guide-download-btn':this.guideCode==null}" @click="download()">取り組みガイドダウンロード</a>
                  </div>
                </div>-->
                <div>
                  <p class="l-formGroup__label">取り組みガイド</p>
                  <div class="btn-download-guide is-disabled"><a href="#">取り組みガイド（準備中）</a></div>
                </div>

              </div>
            </div>
            <div class="l-contentsBox__bottom u-tac js-fixedBarBottom-hide">
              <div class="btn-basic is-inlne is-primary"><button class="js-human-capitalt-save-modal-show" @click="save">保存</button></div>
            </div>
          </div>
        </div>
      </div>

      <!-- フッターリンク -->
      <ul class="human-capitalt-localnav">
        <li><a @click="goPages(1, pageType)" class="link-arrow">採用女性労働者割合</a></li>
        <li><a @click="goPages(2, pageType)" class="link-arrow">平均継続勤務年数</a></li>
        <li class="is-current"><a @click="goPages(3, pageType)" class="link-arrow">離職率</a></li>
        <li><a @click="goPages(4, pageType)" class="link-arrow">女性管理職比率</a></li>
        <li><a @click="goPages(5, pageType)" class="link-arrow">平均年齢</a></li>
        <li><a @click="goPages(6, pageType)" class="link-arrow">障がい者雇用率</a></li>
        <li><a @click="goPages(7, pageType)" class="link-arrow">高年齢者雇用率</a></li>
        <li><a @click="goPages(8, pageType)" class="link-arrow">労災発生件数</a></li>
        <li><a @click="goPages(9, pageType)" class="link-arrow">年次有給休暇取得率</a></li>
        <li><a @click="goPages(10, pageType)" class="link-arrow">1月あたりの平均残業時間</a></li>
        <li><a @click="goPages(11, pageType)" class="link-arrow">育児休業取得率</a></li>
        <li><a @click="goPages(12, pageType)" class="link-arrow">介護休業・短時間勤務取得者数</a></li>
        <li><a @click="goPages(13, pageType)" class="link-arrow">年間平均賃金</a></li>
        <li><a @click="goPages(14, pageType)" class="link-arrow">財務情報</a></li>
      </ul>
    </div> <!-- l-contents end -->

    <!--  アラート画面  -->
    <div class="default-modal js-human-capitalt-save-modal" v-show="this.alertShow">
      <div class="default-modal__bg js-default-modal-close"></div>
      <div class="default-modal__content is-mini">
        <div class="default-modal__header">
          <a class="default-modal__close js-default-modal-close" @click="close(false)"></a>
        </div>
        <div class="default-modal__body">
          <p class="default-modal-message-text">カルテで実績がどう表示されるか、確認しましょう。</p>
          <div class="u-tac">
            <div class="btn-basic is-inlne is-primary"><a @click="closeAndGoPages(true)">カルテを確認する</a></div>
          </div>
          <div class="default-modal__footer has-border-top u-tac is-flex">
            <label class="l-checkbox">
              <input type="checkbox" v-model="isNotDisplayed"> 今後表示しない。
            </label>
            <div class="btn-basic-small is-inlne"><button class="js-default-modal-close" @click="close(true)">閉じる</button></div>
          </div>
        </div>
      </div>
    </div>

  </main>
</template>

<script src="https://code.jquery.com/jquery-3.5.1.min.js "></script>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import DiagCorpHeader from '@/components/parts/diag/DiagCorpHeader.vue';
import { saveAs } from "file-saver";
import Currency from '@/components/parts/human_capital/parts/Currency.vue';
import TurnoverDetail from '@/components/parts/human_capital/TurnoverDetail.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import { maxLength } from 'vuelidate/lib/validators';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import TurnoverLineChart from '@/components/parts/human_capital/parts/TurnoverLineChart.vue';
import constant from '@/const';

export default {
  components: {
    Loading,
    DiagCorpHeader,
    ValidationErrorMessage,
    TextArea,
    Currency,
    TurnoverLineChart,
    TurnoverDetail,
  },
  data() {
    return {
      isParamAccess: false,
      isProcessing: false,
      isRendering: false,
      diagResultList: [],
      latestDiagResult: {
        diagResultId: null,
        diagCourseId: null,
        title: '',
        courseName: '',
        hasRiskDiagResultItems: [],
        existExpiredUpCloseDiagResult: false,
        isOptionDiag: false,
        diagResultLastUpdateDate: null,
        hasVerifiedItem: false,
        diagResultMonthOverMonth: '',
      },
      isNotDisplayed:false,
      isAdmin: false,
      isDiagAvailablePlan: false,
      isShowTutorial: false,

      startYear: null,
      accountMonth: null,
      guideCode: null,

      turnover:{},
      turnover_1: {},
      turnover_2: {},
      turnover_3: {},
      turnover_4: {},
      salesAverage: null,
      grossProfit: null,
      ordinaryProfit: null,
      unit: "％",

     turnoverMale: {},
     turnoverFemale: {},

      alertShow: false, // 保存後、カルテへの遷移プロモートアラート表示フラグ
      noCurrentDataAlert: false, // 最新年度実績データ未登録時アラート表示フラグ
      isAnswerChanged: false,  // 編集チェック
      transitionList: constant.TRANSITION_LIST,
      hrType: 3, // 3:離職率
      pageType: 'report',
      showButton: false,
    }
  },
  validations: {
    turnover: {
//      resultMemo: { maxLength: maxLength(300) }, // アクションメモ
      actionMemo: { maxLength: maxLength(300) }, // アクションメモ
    }
  },
  computed: {
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    corpName() {
      return this.$store.getters['diag/getCorpName'];
    },
    corporateFeatureInfoLabels() {
      return this.$store.getters['diag/getCorporateFeatureInfoLabels'];
    },
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    diagTitle() {
      return this.$store.dispatch('diag/getTitle');
    },
    progress() {
      return Math.floor((this.latestDiagResult.score / this.latestDiagResult.totalScore) * 100);
    },
    score() {
      return this.$store.getters['diag/getScore'];
    },
    totalScore() {
      return this.$store.getters['diag/getTotalScore'];
    },
    hasRiskDiagResultItemsCount() {
      return this.latestDiagResult.hasRiskDiagResultItems.slice(0, 5);
    },
    manageCorpName() {
      return this.$store.getters['auth/getUser'].manageCorpNm;
    },
  },
  // corpIdの監視　法人切替時に実行される
  watch: {
    diagResultId() {
      this.$store.dispatch('diag/initEachSearchForm');
    },
  },
  mounted() {
    jQuery(function ($) {
      $('.human-capitalt-data-past__header').on('click', function(){
        $(this).closest('.human-capitalt-data-past').toggleClass('is-open');
        $(this).closest('.human-capitalt-data-past').find('.human-capitalt-data-past__body').slideToggle(100);
        return false;
      });
      $('.js-human-capitalt-data-past-all-open').on('click', function(){
        $('.human-capitalt-data-past').addClass('is-open');
        $('.human-capitalt-data-past__body').slideDown(100);
      });
      $('.js-human-capitalt-data-past-all-close').on('click', function(){
        $('.human-capitalt-data-past').removeClass('is-open');
        $('.human-capitalt-data-past__body').slideUp(100);
      });

      $('[data-tooltip]').each(function(id) {
        var _text = $(this).attr('data-tooltip');
        var _pos = $(this).attr('data-tooltip-pos');
        var _posclass = '';
        if(_pos == "right") {
          _posclass = 'is-right long';
        }
        if(_pos == "bottom") {
          _posclass = 'is-bottom long';
        }
        $(this).append('<span class="tooltip ' +_posclass + '">' + _text + '</span>');
      });
      $('[data-tooltip]').on('click', function(){
        event.stopPropagation();  // 他の要素へのイベント伝播を停止
        var _h = $(this).children('.tooltip').height();
        _h += 15;
        if (!$(this).children('.tooltip').hasClass('is-right')) {
            $(this).children('.tooltip').css('top', -(_h));
        }
        if ($(this).children('.tooltip').hasClass('is-bottom')) {
            $(this).children('.tooltip').css('top', 'auto');
            $(this).children('.tooltip').css('bottom', -(_h));
        }
        $(this).children('.tooltip').fadeToggle(200);
      });

/*$(document).on('click', '[data-tooltip]', function(event) {
        event.stopPropagation();  // 他の要素へのイベント伝播を停止
        var _h = $(this).children('.tooltip').height();
        _h += 15;
        if (!$(this).children('.tooltip').hasClass('is-right')) {
            $(this).children('.tooltip').css('top', -(_h));
        }
        if ($(this).children('.tooltip').hasClass('is-bottom')) {
            $(this).children('.tooltip').css('top', 'auto');
            $(this).children('.tooltip').css('bottom', -(_h));
        }
        $(this).children('.tooltip').fadeToggle(200);
      });*/

      $(document).on('click', function() {
         $('.tooltip').fadeOut(200); // 画面のどこかがクリックされたときにツールチップを隠す
      });
    })
  },
  created: async function () {
    this.isRendering = true;
    this.isProcessing = true;

    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isAdmin = authority.isAdmin;
    this.isDiagAvailablePlan = authority.isDiagAvailablePlan;

    // パラメータのチェック
    await this.checkParams(this.$route.params);

    this.isRendering = false;
    this.isProcessing = false;

　},
  /**
   * 画面遷移前　編集項目確認
   */
  beforeRouteLeave (to, from, next) {
    if (this.isAnswerChanged) {
      const answer = window.confirm("編集中のものは保存されませんが、よろしいですか？");
      if ( answer ) {
        this.isAnswerChanged = false;
        next(answer);
      }
    } else {
      next();
    }
  },
  methods: {
    async goTop() {
      this.$router.replace({name: 'top', hash: 'section01'});
    },
    /**
     * ガイドコードダウンロード処理
     */
    async download() {
      await saveAs('/ld/api/master/guide/downloadByGuideCd?guideCd=G' + this.guideCode);
    },
    /**
     * パラメータチェック
     */
    async checkParams(params) {
      let res = await this.$axios.post('/ld/api/hr/checkParams', {
        corpId: params.corpId,
      });
      if (res.status === 500) {
        // checkParamsでエラーになったときは、正常なcorpIdが引き継がれていなかったということで、人的資本管理TOP画面に遷移する
        let corpListRet = await this.$axios.post('/ld/api/corporate/getClientCorporateList', {});
        if (corpListRet) {
          if ( this.corpId == null ){
            this.$store.dispatch('diag/setCorpId', corpListRet.data.corporateList[0].corpId);
            this.$store.dispatch('diag/setDiagResultId', null);
            this.$store.dispatch('diag/setDiagResultItemId', null);
          }
          this.$toast.error('企業情報が見つからなかったので、Top画面に戻ります。');
          this.$router.replace({path: '/hr/'+this.corpId+'/topparam'});
        }
      }else{
        if ( this.corpId !== params.corpId ){
          this.$store.dispatch('diag/setCorpId', params.corpId);
          this.$store.dispatch('diag/setDiagResultId', null);
          this.$store.dispatch('diag/setDiagResultItemId', null);
        }
        await this.getCorporateInfo(this.corpId);
        await this.getTurnovers(this.corpId);
      }
    },
    async getCorporateInfo(corpId) {
      if (corpId) {
        let res = await this.$axios.post('/ld/api/hr/getCorporateFeatureInfoLabels', {
          corpId: corpId,
        });
        if (res.status == 200) {
          this.$store.dispatch('diag/setCorpName', res.data.corporateName);
          this.$store.dispatch('diag/setCorporateFeatureInfoLabels',  res.data.corporateFeatureInfoLabels);
        }else{
          this.$toast.error(res.data.message);
          this.isProcessing = false;
        }
      }
    },
    /**
     * 必要な財務情報を取得する
     */
    async getTurnovers(corpId) {

      if ( corpId != null ) {
        let res = await this.$axios.post('/ld/api/hr/getHumanCapitalData', {corpId: this.corpId, hrType: 3}); // 3:離職率
        if (res.status === 200) {
          this.startYear = res.data.inputForm.startYear;
          this.currentYear = res.data.inputForm.currentYear;
          this.accountMonth = res.data.inputForm.accountMonth;

          this.turnover   = res.data.inputForm.turnovers[0]; // 最新年度
          this.turnover_1 = res.data.inputForm.turnovers[1];
          this.turnover_2 = res.data.inputForm.turnovers[2];
          this.turnover_3 = res.data.inputForm.turnovers[3];
          this.turnover_4 = res.data.inputForm.turnovers[4];

          this.guideCode = res.data.inputForm.guideCode;           // ガイドコード
          this.turnoverMale = res.data.inputForm.turnoverMale;     // 業界平均値（離職率・男性）
          this.turnoverFemale = res.data.inputForm.turnoverFemale; // 業界平均値（離職率・女性）

          // グラフの更新
          await this.updateCharts(this.corpId, this.startYear);

          this.noCurrentDataAlert = ( this.turnover.achievementMaleTurnover == null || this.turnover.achievementFemaleTurnover == null);

        }else{
          // error
          this.$router.replace({path: '/hr/'+this.corpId+'/topparam'});
        }
        this.isProcessing = false;
      }
      return corpId;
    },
    // 特殊ダイアログのクローズ
    close(saveFlag){
      if ( saveFlag ) {
        if (this.isNotDisplayed) {
          this.$store.dispatch('auth/setIsShowDiagHumanCapitalReport', false);
          this.$axios.post('/ld/api/user/updateIsShowTutorial', { isShowDiagHumanCapitalReport: this.isNotDisplayed,});
        }
      }
      this.alertShow = false;
    },
    closeAndGoPages(saveFlag) {
      this.close(saveFlag);
      this.goTop();
    },
    // 入力データ編集フラグ
    changeInput(){
      this.isAnswerChanged = true
    },
    /**
     * 保存処理
     */
    async save() {
      this.editMode(false);
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/hr/saveActionMemo', {
          data: this.turnover,
          hrType: this.hrType,
        });
        if (res.status === 200) {
          this.$toast.info('登録が完了しました');
          this.isAnswerChanged = false;
          this.alertShow = this.$store.getters['auth/getUser'].tutorial.isShowDiagHumanCapitalReport;
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }else {
        this.$toast.error('入力データが不正です。');
      }
    },
    print() {
      window.print();
      return false;
    },
    /**
     * 最新年度以外の入力部の表示・非表示処理
     */
    toggle(){
      const headerElm = this.$refs.header;
      const bodyElm   = this.$refs.body;
　　　//トグルでクラスが切り替わる
      headerElm.classList.toggle("is-open");
      if(headerElm.classList.contains("is-open")){
        //要素の高さをstyle属性で付与
        bodyElm.style.height = bodyElm.scrollHeight + 'px';
      }else{
      //要素の高さを0にする
        bodyElm.style.height = 0;
      }
    },

    /**
     * アクションメモの編集モード切替
     */
    editMode(isEdit){
      const memoElm = this.$refs.memoEdit
      if ( isEdit == null || memoElm.classList.contains("is-edit") ){
        memoElm.classList.toggle("is-edit");
        }
    },
    // TextArea内のurl文字列をリンクに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    // 遷移関数
    goPages(num, type) {
      this.$router.replace({path: '/hr/'+this.corpId + '/' + this.transitionList[num] + '_' + type});
    },

    /**
     * グラフを更新します
     */
    async updateCharts(corpId, year){
      this.showButton = false;
      if (this.$refs.lineChart) {
        await this.$refs.lineChart.recreateChart(corpId, year); // 離職率・男性
      }
      if (this.$refs.lineChart2) {
        await this.$refs.lineChart2.recreateChart(corpId, year); // 離職率・女性
      }
      this.showButton = true;
    },
    // 特徴データを取得して設定
    async getCorporateFeatureInfoLabels(corpId) {
      let res = await this.$axios.post('/ld/api/corporate/getCorporateFeatureInfoLabels', {
        corpId: corpId,
      });
      if (res) {
        this.$store.dispatch('diag/setCorporateFeatureInfoLabels', res.data.corporateFeatureInfoLabels);
      }
    },
    changeDiagTitle(value) {
      this.execChangeDiagTitle = value;
    },
    emitSelectCorpList(params) {
      this.$store.dispatch('diag/setCorpId', params.corpId);
      this.$store.dispatch('diag/setCorpName', params.corpNm);

      this.$router.replace({name: 'hr-turnover-report', params: { corpId: this.corpId }});
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    },
    showTutorialModal(value) {
      this.isShowTutorial = value;
    },
  }
}
</script>

<style scoped>
.diagtitlechange-fade-enter-active {
  transition: all .2s ease;
}
.diagtitlechange-fade-leave-active {
  transition: all .2s ease;
}
.diagtitlechange-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.diagtitlechange-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.tutorialmodal-fade-enter-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-leave-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-enter {
  transform: translateY(-50px);
  opacity: 0;
}
.tutorialmodal-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
.disabled-guide-download-btn {
  pointer-events: none;
  opacity: 0.5;
}
</style>
